/**
 * Converts an ISO date string (YYYY-MM-DD) to US format (MM/DD/YYYY).
 */
export function formatDob(iso: string): string {
  const parts = iso.split("-");
  if (parts.length !== 3) return iso;
  const [y, m, d] = parts;
  return `${m}/${d}/${y}`;
}
